// extracted by mini-css-extract-plugin
export default {"column":"rates_table_header_column_column__6dQIx","columnContent":"rates_table_header_column_columnContent__fVUcx","columnLabel":"rates_table_header_column_columnLabel__+wrEF"};